import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'utclub-rating',
  templateUrl: './utclub-rating.component.html'
})
export class UtclubRatingComponent implements OnInit {
  @Input() rating: number;
  @Input() enumString: string = 'InquiryRating';

  ngOnInit(): void {
  }
}
